import {
  type FormSectionFormFieldsGroup,
  type Maybe,
} from "~/__generated__/graphql";
import { FormFieldRenderer } from "./FormFieldRenderer";
import _ from "lodash";

export default function Group({
  fieldGroupName,
  leftSection,
  rightSection,
  leftFieldGroupKey = "FormSectionGroupLeftSection",
  rightFieldGroupKey = "FormSectionGroupRightSection",
}: FormSectionFormFieldsGroup & {
  leftFieldGroupKey?: string;
  rightFieldGroupKey?: string;
}) {
  const fields = _.compact(_.flatten(_.zip(leftSection, rightSection))).map(
    (f) => ({
      ...f,
      fieldGroupName: f.fieldGroupName
        ?.replace(leftFieldGroupKey, "Field")
        .replace(rightFieldGroupKey, "Field"),
    }),
  );

  return (
    <div className="grid grid-cols-1 gap-7 lg:grid-cols-2">
      <FormFieldRenderer
        fieldGroupKey="Field"
        slices={
          fields as Maybe<
            Maybe<{ fieldGroupName: string; [key: string]: unknown }>[]
          >
        }
      />
    </div>
  );
}
